import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/useAuth';


const ProtectedRoute = ({ children, allowedRoles }) => {
    const { user, accessToken, loading } = useAuth();
    const location = useLocation();
    if (loading) return <div>Checking authorization...</div>
    // 1. Check if user is logged in
    if (!accessToken) {
        console.log("No token found, redirecting to login");
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // 2. Check if user has the required role
    // If allowedRoles is provided, verify the user's role is in that list
    if (allowedRoles && !allowedRoles.includes(user?.role)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
};

export default ProtectedRoute;